import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    isbuy: parseInt(window.sessionStorage.isbuy)
}
const mutations = {
    
      setIsBuy(state,tag){
        state.isbuy=tag
      }
    
}
export default new Vuex.Store({
    state,
    mutations
    
})



// WEBPACK FOOTER //
// ./src/vuex/store.js